import { render, staticRenderFns } from "./DocumentAssetList.vue?vue&type=template&id=1fb87b6e&lang=pug&"
import script from "./DocumentAssetList.vue?vue&type=script&lang=js&"
export * from "./DocumentAssetList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAssetList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports